import React from 'react';
import { ContainerMain, GifLoading } from './style';

import gifLoading from '../../../assets/gifs/loading.png';

export default function FakeModalLoading(): JSX.Element {
  return (
    <ContainerMain>
      <GifLoading src={gifLoading} alt="gif de carregamento" />
    </ContainerMain>
  );
}
